<template>
  <div>
    <a-modal
      :title="$t('formAbout.modal.detail')"
      v-model="visible"
      :destroyOnClose="true"
      :footer="null"
      @cancel="handleCancel"
      width="888px">
      <a-tabs defaultActiveKey="1" @change="callback">
        <a-tab-pane tab="Table" key="1">
          <!-- 所有自定义字段 -->
          <a-table
            :dataSource="allFieldsData"
            :columns="allColumns"
            :pagination="false"
            rowKey="fieldName"
            :scroll="{y: 333}">
          </a-table>
        </a-tab-pane>
        <a-tab-pane tab="Json" key="2">
          <!-- 渲染行号 -->
          <div v-if="false" class="line-box" id="lineBox">
            <ul>
              <li v-for="(lineNo, index) in lines" :key="index">{{ lineNo }}</li>
            </ul>
          </div>
          <!-- json视图 -->
          <json-viewer
            :value="jsonData"
            :expand-depth="depth"
            :copyable="copy"
            :boxed="boxed"
            :sort="sort">
          </json-viewer>
        </a-tab-pane>
      </a-tabs>
    </a-modal>
  </div>
</template>
<script>
export default {
  props: {
    mShow: {
      type: Boolean,
      default: false
    },
    allColumns: {
      type: Array,
      default: () => []
    },
    allFieldsData: {
      type: Array,
      default: () => []
    },
    // json数据源
    jsonData: {
      type: Object,
      default: () => {}
    },
    // json数据默认展开层次
    depth: {
      type: Number,
      default: 3
    },
    // json数据可否复制
    copy: {
      type: Boolean,
      default: false
    },
    // 是否新增box样式
    boxed: {
      type: Boolean,
      default: false
    },
    // 是否排序
    sort: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visible: {
      get: function () {
        return this.mShow
      },
      set: function (newVal) {
        return newVal
      }
    }
  },
  data () {
    return {
      lines: [] // 行号
    }
  },
  methods: {
    callback (key) {
      // console.log(key)
      // this.$nextTick(() => {
      //   this.renderLine()
      // })
    },
    handleCancel (e) {
      this.$emit('cancel')
    },
    // 渲染行号
    renderLine () {
      // console.log(document.getElementById('lineBox'))
    }
  }
}
</script>
<style lang="less" scoped>
// Ant tab相关
  /deep/.ant-tabs-content {
    position: relative;
  }
  .line-box {
    position: absolute;
    left: 100%;
    top: 0;
    z-index: 99;
    width: 28px;
    height: 100%;
    background-color: #E9E9E9;
    color: #333;
    li {
      height: 20px;
      line-height: 20px;
      font-size: 12px;
    }
  }
// json视图相关
  // /deep/.jv-container.jv-light .jv-item.jv-object {
  //   height: 20px;
  //   display: inline-block;
  // }
  // /deep/.jv-node .jv-node {
  //   height: 20px;
  // }
  /deep/.jv-container .jv-code {
    // padding: 0 20px 0 30px;
    padding: 0 20px;
    overflow: auto;
  }
</style>
